import {osVersion, mobileModel} from 'react-device-detect';
import {getAppVersion, isWebview} from '../helper';

const MOBILE_INFO_HEADER = '--- Device Information ---';

const MOBILE_INFO_LABEL = {
  mobileVersion: 'version',
  mobileModel: 'model',
  mobileOsVer: 'OS Version',
} as const;

export const formatMobileInfo = (isMobile: boolean): string => {
  // pc면 빈문자열
  if (!isMobile) {
    return '';
  }
  // 앱(웹뷰) version=앱버전, model=모델명, OSVersion=모델os버전
  // 모웹 version=1, model=web, OSVersion=web(값 고정)
  const info = isWebview
    ? {
        mobileVersion: getAppVersion() || '1.0.0',
        mobileModel,
        mobileOsVer: osVersion,
      }
    : {
        mobileVersion: '1',
        mobileModel: 'web',
        mobileOsVer: 'web',
      };

  const lines = Object.entries(info)
    .map(([key, value]) =>
      value ? `${MOBILE_INFO_LABEL[key]}: ${value}` : null,
    )
    .filter(Boolean) as string[];

  return lines.length
    ? `\r\n\r\n\r\n${MOBILE_INFO_HEADER}\r\n${lines.join('\r\n')}`
    : '';
};
